<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div
            class="col-sm-12 d-flex align-items-center justify-content-between"
          >
            <div>
              <h3 class="page-title mb-1">Danh sách hướng dẫn</h3>
              <ul class="breadcrumb mb-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Danh sách hướng dẫn</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Đang tải hướng dẫn...</span>
          </div>
          <p class="mt-2">Đang tải hướng dẫn...</p>
        </div>

        <div v-else-if="error" class="alert alert-danger">
          <i class="la la-exclamation-triangle mr-1"></i> {{ error }}
        </div>

        <div v-else-if="!items || items.length === 0" class="text-center py-5">
          <i class="la la-info-circle fa-2x text-muted mb-2"></i>
          <p>Chưa có hướng dẫn nào được ban hành.</p>
        </div>

        <div v-else id="noiQuyAccordion">
          <div
            class="card card-container"
            v-for="(item, index) in items"
            :key="item.id"
          >
            <div class="card-header" :id="'heading-' + item.id">
              <h5 class="mb-0">
                <button
                  class="btn btn-link btn-block text-left d-flex justify-content-between align-items-center"
                  data-toggle="collapse"
                  :data-target="'#collapse-' + item.id"
                  :aria-expanded="index === 0 ? 'true' : 'false'"
                  :aria-controls="'collapse-' + item.id"
                >
                  <span class="font-weight-bold">{{ item.ten }}</span>
                  <i class="la la-chevron-down"></i>
                </button>
              </h5>
              <small
                class="text-muted pl-3 d-flex flex-wrap align-items-center"
              >
                <span class="mr-3 mb-1">
                  <span class="text-danger" v-if="item.tenPhongBan">
                    <i class="la la-users mr-1"></i> Dành cho:
                    {{ item.tenPhongBan }}
                  </span>
                  <span class="text-info" v-else>
                    <i class="la la-globe mr-1"></i> Hướng dẫn chung
                  </span>
                </span>

                <span class="mb-1">
                  <i class="la la-calendar-alt mr-1"></i>
                  Hiệu lực từ: {{ formatDate(item.ngayHieuLuc) }}
                </span>
              </small>
            </div>

            <div
              :id="'collapse-' + item.id"
              class="collapse"
              :aria-labelledby="'heading-' + item.id"
              data-parent="#noiQuyAccordion"
            >
              <div
                class="card-body noi-dung-content"
                v-html="item.noiDung"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { NoiQuyApi } from "@/services/noiQuyService"; // Import service của bạn

const items = ref([]);
const loading = ref(true);
const error = ref(null);

const fetchUserNoiQuy = async () => {
  loading.value = true;
  error.value = null;
  try {
    // Gọi API list mà không cần tham số (page, size, filter)
    // Backend sẽ tự phân quyền và trả về list phù hợp cho user
    // Yêu cầu backend trả về size lớn (vd: 200) để tránh phân trang
    const data = await NoiQuyApi.public({
      page: 0,
      size: 200,
      sort: "ngayHieuLuc,desc",
      loai: "HUONGDAN",
    });
    items.value = data.data.content || [];
  } catch (e) {
    error.value =
      e?.response?.data?.message ||
      e?.message ||
      "Không thể tải danh sách hướng dẫn.";
  } finally {
    loading.value = false;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("vi-VN");
  } catch (e) {
    return dateString;
  }
};

onMounted(() => {
  fetchUserNoiQuy();
});
</script>

<style scoped>
.card {
  background-color: #ffffff00;
  border: none !important;
  box-shadow: none !important;
}
.card-header {
  background: linear-gradient(to left, #fffcee 0%, #fff 50%, #e6ffee 100%);
}

/* Style cho nội dung v-html (tương tự trang chi tiết) */
.noi-dung-content {
  line-height: 1.6;
  background-color: #fdfdfd;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
}
.noi-dung-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
.noi-dung-content :deep(video) {
  max-width: 100%;
  height: auto !important;
  border-radius: 4px;
}

/* Style cho Accordion Button (Bootstrap 4) */
.btn-link {
  color: #333;
  text-decoration: none;
}
.btn-link:hover {
  color: #0056b3;
  text-decoration: none;
}
/* Xoay icon chevron khi mở */
.btn-link[aria-expanded="true"] .fa-chevron-down {
  transform: rotate(180deg);
}
.btn-link .fa-chevron-down {
  transition: transform 0.2s ease-in-out;
}
</style>
